export const Logo = () => import('../../components/Logo.vue' /* webpackChunkName: "components/logo" */).then(c => wrapFunctional(c.default || c))
export const DevelopmentAuthenticationCookie = () => import('../../components/development/authentication-cookie.vue' /* webpackChunkName: "components/development-authentication-cookie" */).then(c => wrapFunctional(c.default || c))
export const DevelopmentSection = () => import('../../components/development/development-section.vue' /* webpackChunkName: "components/development-section" */).then(c => wrapFunctional(c.default || c))
export const DevelopmentFeatureQuery = () => import('../../components/development/feature-query.vue' /* webpackChunkName: "components/development-feature-query" */).then(c => wrapFunctional(c.default || c))
export const DevelopmentJsonViewer = () => import('../../components/development/json-viewer.vue' /* webpackChunkName: "components/development-json-viewer" */).then(c => wrapFunctional(c.default || c))
export const DevelopmentLogPublisher = () => import('../../components/development/log-publisher.vue' /* webpackChunkName: "components/development-log-publisher" */).then(c => wrapFunctional(c.default || c))
export const DevelopmentNavigator = () => import('../../components/development/navigator.vue' /* webpackChunkName: "components/development-navigator" */).then(c => wrapFunctional(c.default || c))
export const DevelopmentStatisticsMvp = () => import('../../components/development/statistics-mvp.vue' /* webpackChunkName: "components/development-statistics-mvp" */).then(c => wrapFunctional(c.default || c))
export const DevelopmentTenantSelector = () => import('../../components/development/tenant-selector.vue' /* webpackChunkName: "components/development-tenant-selector" */).then(c => wrapFunctional(c.default || c))

// nuxt/nuxt.js#8607
function wrapFunctional(options) {
  if (!options || !options.functional) {
    return options
  }

  const propKeys = Array.isArray(options.props) ? options.props : Object.keys(options.props || {})

  return {
    render(h) {
      const attrs = {}
      const props = {}

      for (const key in this.$attrs) {
        if (propKeys.includes(key)) {
          props[key] = this.$attrs[key]
        } else {
          attrs[key] = this.$attrs[key]
        }
      }

      return h(options, {
        on: this.$listeners,
        attrs,
        props,
        scopedSlots: this.$scopedSlots,
      }, this.$slots.default)
    }
  }
}
